/**
 * Public data-camlin-companion-* annotation attribute constants (doc 116 §2.2).
 * Follows avatar-css-hooks.mdc discipline — public contract, never rename after ship.
 */

export const CAMLIN_COMPANION_ATTR = {
  /** Script tag: publishable site key (identifies, does not authorize). */
  key: 'data-camlin-companion-key',
  /** Section landmark for scroll/highlight targets. */
  section: 'data-camlin-companion-section',
  /** Named operable action (maps to manifest pack action id). */
  action: 'data-camlin-companion-action',
  /** Form field binding (e.g. contact.email). */
  field: 'data-camlin-companion-field',
  /** Embed shell landmarks (companion-owned chrome). */
  shell: 'data-camlin-companion-shell',
  badge: 'data-camlin-companion-badge',
  consent: 'data-camlin-companion-consent',
  nudge: 'data-camlin-companion-nudge',
  panel: 'data-camlin-companion-panel'
} as const;

export type CamlinCompanionAttributeName =
  (typeof CAMLIN_COMPANION_ATTR)[keyof typeof CAMLIN_COMPANION_ATTR];

export interface CompanionAnnotatedElement {
  sectionId?: string;
  actionId?: string;
  fieldId?: string;
}

export function readCompanionAnnotations(element: Element): CompanionAnnotatedElement {
  return {
    sectionId: element.getAttribute(CAMLIN_COMPANION_ATTR.section) || undefined,
    actionId: element.getAttribute(CAMLIN_COMPANION_ATTR.action) || undefined,
    fieldId: element.getAttribute(CAMLIN_COMPANION_ATTR.field) || undefined
  };
}

export function queryCompanionAnnotatedSections(root: ParentNode = document): Element[] {
  return Array.from(
    root.querySelectorAll(`[${CAMLIN_COMPANION_ATTR.section}]`)
  );
}

export function queryCompanionAnnotatedActions(root: ParentNode = document): Element[] {
  return Array.from(
    root.querySelectorAll(`[${CAMLIN_COMPANION_ATTR.action}]`)
  );
}

export function queryCompanionAnnotatedFields(root: ParentNode = document): Element[] {
  return Array.from(
    root.querySelectorAll(`[${CAMLIN_COMPANION_ATTR.field}]`)
  );
}
